/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { GoogleprotobufAny } from '../models/GoogleprotobufAny';
import { HttpFile } from '../http/http';

export class GooglerpcStatus {
    'code'?: number;
    'message'?: string;
    'details'?: Array<GoogleprotobufAny>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "code",
            "baseName": "code",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        },
        {
            "name": "details",
            "baseName": "details",
            "type": "Array<GoogleprotobufAny>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return GooglerpcStatus.attributeTypeMap;
    }

    public constructor() {
    }
}

